import './polyfil/custom-event';
import './polyfil/sticky';
import './lib/impetus';
import './lib/component';
import './lib/lazyload';
import './lib/resize_sensor';
import './lib/auth';
import './lib/setting';
import './lib/sentry';
import '../../../../../www/module/front/app/creator/entry/ad.js';

await import('../../../shared/style/global.scss');
await import('./lib/translation');
await import('../../../../../www/module/front/app/creator/entry/init.js');
await import('./lib/channel_talk');
await import('./lib/history');
await import('./lib/headerHydration.ts');
await import('./lib/runeHydration');

export {};
